import { render, staticRenderFns } from "./NotFound.vue?vue&type=template&id=2042d718&scoped=true"
var script = {}
import style0 from "./NotFound.vue?vue&type=style&index=0&id=2042d718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2042d718",
  null
  
)

export default component.exports